export default "__VITE_ASSET__Dpjj9N32__"